import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import IntegrationPanelContainer from "./IntegrationPanelContainer";
import useAiConnections from "../../../../hooks/useAiConnections";
import { onCreatorPanelNavigatePath } from "../../../../utils/navigationUtils";
import { NavigationId } from "../../../../navigation/AppParamList";
import { CreatorSettingsTab } from "../../../../screens/Profile/CreatorPanels/CreatorSettingsPanel";

const AI_CLIENT_LOGOS = [
  "logos:claude-icon",
  "logos:codex",
  "logos:google-gemini-icon",
  "logos:grok-icon",
];

export const McpPanelSection = () => {
  const navigate = useNavigate();
  const { data } = useAiConnections();

  const hasConnectedApps = useMemo(() => (data?.apps.length ?? 0) > 0, [data]);

  // Always opens the MCP tab, like the API card; accounts without the plan see
  // the upgrade prompt there.
  const onActionPress = useCallback(() => {
    onCreatorPanelNavigatePath(
      navigate,
      NavigationId.HOME_SETTINGS,
      CreatorSettingsTab.MCP
    );
  }, [navigate]);

  return (
    <IntegrationPanelContainer
      isConnected={false}
      connectedContent={null}
      title="Connect AI Tools (MCP)"
      description="Use Markit from Claude and other AI assistants to send texts, manage your audience, and more."
      actionLabel={hasConnectedApps ? "Manage" : "Set Up"}
      onActionPress={onActionPress}
      icon={
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 36px)",
            gap: 8,
            width: 80,
            height: 80,
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          {AI_CLIENT_LOGOS.map((logo) => (
            <Icon key={logo} icon={logo} height={36} width={36} />
          ))}
        </div>
      }
    />
  );
};
